import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

import InputField from "./inputField";
import PsContext from "../../../context";
import { upperCase } from "../../../utils";

const GuardianDetails = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);

  const [basic, setBaisc] = useState([]);
  const [marks, setMarks] = useState([]);
  const [preference, setPreference] = useState([]);

  const field = (fieldName) => {
    if (props.data && props.data[fieldName]) return props.data[fieldName];
  };

  return (
    <>
      <InputField
        label="Guardian Name"
        value={upperCase(field("guardian_name"))}
      />

      <InputField
        label="Guardian Relationship"
        value={upperCase(field("guardian_relationship"))}
      />

      <InputField
        label="Guardian Phone"
        value={upperCase(field("guardian_phone"))}
      />
    </>
  );
};

export default GuardianDetails;
